import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import API from '@/lib/API';
import { Network } from '@/types';

@Module
export default class Networks extends VuexModule {
  data: Network[] = []

  get networks(): Network[] {
    return this.data;
  }

  @Mutation
  setNetworks({ networks }: { networks: Network[] }) {
    console.log('mutations:setNetworks'); // eslint-disable-line no-console

    const data: Network[] = [];

    networks.forEach((doc) => {
      data.push({
        id: doc.id,
        name: doc.name,
        shortname: doc.shortname,
        logo: doc.logo,
        primaryColor: doc.primaryColor,
        title: doc.title,
      });
    });

    this.data = data;

    return Promise.resolve();
  }

  @Action({ rawError: true })
  async initNetworks() {
    console.log('actions:initNetworks'); // eslint-disable-line no-console

    return this.context.dispatch('updateNetworks');
  }

  @Action({ rawError: true })
  async updateNetworks() {
    console.log('actions:updateNetworks'); // eslint-disable-line no-console

    const networks = await API.getNetworks();

    if (networks instanceof Error) return Promise.reject(networks);

    return this.context.commit('setNetworks', { networks });
  }
}
